import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "@firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyCVLnhMgDJm1gH8SYcB_e8Elhss3Ly9jPI",
  authDomain: "myblogs-fe0bf.firebaseapp.com",
  projectId: "myblogs-fe0bf",
  storageBucket: "myblogs-fe0bf.appspot.com",
  messagingSenderId: "868350747212",
  appId: "1:868350747212:web:32fc0bfe20cae59afecae9",
  measurementId: "G-WP40ETLJDW",
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
// const analytics = getAnalytics(app);

// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCVLnhMgDJm1gH8SYcB_e8Elhss3Ly9jPI",
//   authDomain: "myblogs-fe0bf.firebaseapp.com",
//   projectId: "myblogs-fe0bf",
//   storageBucket: "myblogs-fe0bf.appspot.com",
//   messagingSenderId: "868350747212",
//   appId: "1:868350747212:web:32fc0bfe20cae59afecae9",
//   measurementId: "G-WP40ETLJDW"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
